import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import useNavigationPage from '../../../hooks/useNavigationPage';
import useTransportationOrderService from '../../../app/services/hooks/useTransportationOrderService';
import useWarehouseOrderService from '../../../app/services/hooks/useWarehouseOrderService';
import useOrderService from '../../../app/services/hooks/useOrderService';
import DefaultCard from '../../../components/default/DefaultCard';
import ButtonCreate from '../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../components/default/DefaultModal';
import OrderCreate from '../components/OrderCreate';
import { Roles } from '../../../app/shared/enums';
import OrdersUnifiedDataTable from '../components/tables/GeneralOrderDataTable';
import { defaultOrderFilters, OrderFilters } from '../../../app/models/Order';

const OrdersContainer = () => {
  const { auth } = useContext(AuthContext);
  const { navigationPage } = useNavigationPage();

  const {
    getExcelAllTransportationOrders,
    canEditTransportationOrder,
    getOrders,
    fetchingGetOrders,
  } = useTransportationOrderService();

  const {
    canEditWarehouseOrder,
  } = useWarehouseOrderService();

  const { deleteUnifiedOrder } = useOrderService();

  const [orders, setOrders]         = useState<any[]>([]);
  const [totalRows, setTotalRows]   = useState<number>(0);
  const [filter, setFilter]         = useState<OrderFilters>(defaultOrderFilters);
  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    reloadAll();
  }, [filter]);

  const reloadAll = () => {
    getOrders(filter, {
      onSuccess: ({ data }) => {
        setOrders(data.orders);
        setTotalRows(data.total_rows);
      },
      onError: () => navigationPage('/'),
    });
  };

  const destroy = (id: number) => {
    deleteUnifiedOrder(id, { onSuccess: reloadAll, onError: console.error });
  };

  const edit = (id: number, type: 'transporte' | 'almacenamiento') => {
    const sector = type === 'transporte' ? 'transport' : 'warehouse';
    if (type === 'transporte') {
      canEditTransportationOrder({
        onSuccess: () => navigationPage(`/pedidos/${id}/edit/${sector}`),
        onError: console.error,
      });
    } else {
      canEditWarehouseOrder({
        onSuccess: () => navigationPage(`/pedidos/${id}/edit/${sector}`),
        onError: console.error,
      });
    }
  };

  const show = (id: number, type: 'transporte' | 'almacenamiento') => {
    const sector = type === 'transporte' ? 'transport' : 'warehouse';
    navigationPage(`/pedidos/${id}/show/${sector}`);
  };

  return (
    <>
      <DefaultCard>
        <div className="row">
          <div className="col">
            {auth?.roles && !auth.roles.includes(Roles.RUNNER) && (
              <ButtonCreate
                callbackCreate={() => setShowCreate(true)}
                title="Nuevo Pedido"
              />
            )}
          </div>
        </div>

        <OrdersUnifiedDataTable
          orders={orders}
          totalRows={totalRows}
          loading={fetchingGetOrders}
          filter={filter}
          setFilter={setFilter}
          edit={edit}
          destroy={destroy}
          show={show}
          downloadExcel={() => getExcelAllTransportationOrders(filter)}
          callbackSuccess={reloadAll}
        />
      </DefaultCard>

      <DefaultModal
        show={showCreate}
        handleClose={() => setShowCreate(false)}
        title="Crear Pedido"
        backdrop
        showFooter={false}
      >
        <OrderCreate
          onSaved={() => { setShowCreate(false); reloadAll(); }}
          onCancel={() => setShowCreate(false)}
          onError={() => setShowCreate(false)}
        />
      </DefaultModal>
    </>
  );
};

export default OrdersContainer;
